<p-toast position="top-right"></p-toast>
<p-skeleton *ngIf="isLoading" width="100%" height="100%" styleClass="block mt-4"></p-skeleton>

<div *ngIf="!isLoading && form" class="flex flex-col">
    <!-- ===================== HEADER FISSO: dati rilievo + azioni ===================== -->
    <div class="card mb-3" [formGroup]="form">
        <div class="flex flex-wrap items-center justify-between gap-3">
            <div>
                <div class="font-semibold text-xl leading-tight">Deviatoio {{ deviatoio?.identificativo }}</div>
                <span class="dev-type-badge" *ngIf="deviatoio?.deviatoioTipologia?.labelFe">{{ deviatoio?.deviatoioTipologia?.labelFe }}</span>
            </div>
            <div class="flex items-center gap-2">
                <button pButton type="button" icon="pi pi-save" label="Salva" class="p-button-success" (click)="salva()"></button>
            </div>
        </div>

        <hr class="rilievo-divider" />

        <!-- Dati rilievo: precompilati (data = oggi), modificabili -->
        <div class="rilievo-dati-grid">
            <div class="rilievo-field">
                <label>Data rilevamento <span class="req">*</span></label>
                <p-datePicker formControlName="dataRilevamento" [showTime]="true" hourFormat="24" dateFormat="dd/mm/yy" showIcon="true" styleClass="w-full"></p-datePicker>
            </div>
            <div class="rilievo-field">
                <label>Tecnico <span class="req">*</span></label>
                <p-select [options]="tecnici" formControlName="tecnico" optionLabel="label" placeholder="Seleziona tecnico" styleClass="w-full"></p-select>
            </div>
            <div class="rilievo-field">
                <label>Strumento utilizzato <span class="req">*</span></label>
                <p-select [options]="strumenti" formControlName="strumentoUtilizzato" optionLabel="label" placeholder="Seleziona strumento" styleClass="w-full"></p-select>
            </div>
        </div>
    </div>

    <!-- ===================== NAV A CHIP (tablet / mobile) ===================== -->
    <div class="rilievo-chips" *ngIf="utils.isMobile$ | async">
        <button
            *ngFor="let s of sections"
            pButton
            type="button"
            [label]="s.label"
            [icon]="sectionFilled(s.key) ? 'pi pi-check-circle' : s.icon"
            [severity]="activeSection === s.key ? 'primary' : 'secondary'"
            [outlined]="activeSection !== s.key"
            (click)="activeSection = s.key"
        ></button>
    </div>

    <!-- ===================== LAYOUT: sidebar (desktop) + contenuto ===================== -->
    <div class="rilievo-layout">
        <!-- SIDEBAR sezioni (solo desktop) -->
        <div class="rilievo-sidebar" *ngIf="!(utils.isMobile$ | async)">
            <button *ngFor="let s of sections" type="button" (click)="activeSection = s.key" class="rilievo-nav-item" [class.active]="activeSection === s.key">
                <i class="pi nav-icon" [ngClass]="sectionFilled(s.key) ? 'pi-check-circle done' : s.icon"></i>
                <span>{{ s.label }}</span>
            </button>
        </div>

        <!-- CONTENUTO della sezione attiva -->
        <div class="card rilievo-content">
            <!-- ----- MISURE ----- -->
            <div *ngIf="activeSection === 'misure'">
                <app-misure
                    *ngIf="normativa && deviatoio"
                    [mode]="mode"
                    [formReady]="formReady"
                    [deviatoio]="deviatoio"
                    [form]="form"
                    [normativa]="normativa"
                    [(selectedTab)]="selectedTab"
                    [(selectedTabIntersezione)]="selectedTabIntersezione"
                ></app-misure>
            </div>

            <!-- ----- INDAGINE VISIVA: accordion (una area aperta per volta) ----- -->
            <div *ngIf="activeSection === 'indagine'" [formGroup]="form" class="iv-accordion">
                <div class="iv-panel">
                    <button type="button" class="iv-panel-head" [class.open]="openIv === 'usura'" (click)="toggleIv('usura')">
                        <span>Stato usura</span>
                        <i class="pi" [ngClass]="openIv === 'usura' ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>
                    <div class="iv-panel-body" *ngIf="openIv === 'usura'">
                        <app-indagine-usura [form]="form" [tipoScambio]="tipoScambio" [opzioniStatoUsura]="opzioniStatoUsura"></app-indagine-usura>
                    </div>
                </div>

                <div class="iv-panel">
                    <button type="button" class="iv-panel-head" [class.open]="openIv === 'coppie'" (click)="toggleIv('coppie')">
                        <span>Coppia ago-contrago</span>
                        <i class="pi" [ngClass]="openIv === 'coppie' ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>
                    <div class="iv-panel-body" *ngIf="openIv === 'coppie'">
                        <app-indagine-coppie [form]="form" [tipoScambio]="tipoScambio" [opzioniCoppie]="opzioniCoppiaAgoContrago"></app-indagine-coppie>
                    </div>
                </div>

                <div class="iv-panel">
                    <button type="button" class="iv-panel-head" [class.open]="openIv === 'traverse'" (click)="toggleIv('traverse')">
                        <span>Traverse</span>
                        <i class="pi" [ngClass]="openIv === 'traverse' ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>
                    <div class="iv-panel-body" *ngIf="openIv === 'traverse'">
                        <app-indagine-traverse [form]="form" [tipoScambio]="tipoScambio" [opzioniStatoUsura]="legnami"></app-indagine-traverse>
                    </div>
                </div>

                <div class="iv-panel">
                    <button type="button" class="iv-panel-head" [class.open]="openIv === 'attacchi'" (click)="toggleIv('attacchi')">
                        <span>Attacchi e bulloneria</span>
                        <i class="pi" [ngClass]="openIv === 'attacchi' ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>
                    <div class="iv-panel-body" *ngIf="openIv === 'attacchi'">
                        <app-indagine-attacchi-bulloneria [form]="form" [tipoScambio]="tipoScambio" [opzioniStatoUsura]="bulloneria"></app-indagine-attacchi-bulloneria>
                    </div>
                </div>

                <div class="iv-panel">
                    <button type="button" class="iv-panel-head" [class.open]="openIv === 'interventi'" (click)="toggleIv('interventi')">
                        <span>Interventi necessari</span>
                        <i class="pi" [ngClass]="openIv === 'interventi' ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>
                    <div class="iv-panel-body" *ngIf="openIv === 'interventi' && formReady">
                        <app-indagine-interventi [form]="form" [deviatoioId]="deviatoio.id" [dataRilevamento]="form.get('dataRilevamento')?.value"></app-indagine-interventi>
                    </div>
                </div>

                <div class="iv-panel">
                    <button type="button" class="iv-panel-head" [class.open]="openIv === 'note'" (click)="toggleIv('note')">
                        <span>Note</span>
                        <i class="pi" [ngClass]="openIv === 'note' ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>
                    <div class="iv-panel-body" *ngIf="openIv === 'note'">
                        <app-indagine-note [form]="form"></app-indagine-note>
                    </div>
                </div>
            </div>

            <!-- ----- FOTO ----- -->
            <div *ngIf="activeSection === 'foto'" [formGroup]="form">
                <div class="font-semibold text-2xl mb-2">Immagini interventi</div>
                <app-indagine-immagini *ngIf="formReady" [form]="form" [deviatoioId]="deviatoio.id!" [dataRilevamento]="form.get('dataRilevamento')?.value"></app-indagine-immagini>
            </div>

            <!-- ----- STORICO ----- -->
            <div *ngIf="activeSection === 'storico'">
                <app-storico [deviatoioId]="deviatoio.id!" [normativaId]="normativa[0].id" [tipoDeviatoio]="deviatoio.deviatoioTipologia.id"></app-storico>
            </div>
        </div>
    </div>
</div>

<!-- Overlay salvataggio -->
<p-blockUI [blocked]="isLoading" fullScreen="true">
    <div class="fixed inset-0 flex items-center justify-center text-white z-[9999] w-full">
        <div class="flex items-center gap-3">
            <i class="pi pi-spin pi-cog text-5xl"></i>
            <p class="text-lg font-semibold">Caricamento in corso...</p>
        </div>
    </div>
</p-blockUI>
